export enum SessionStorageKey {
    TOKEN = 'TOKEN',
    USER = 'USER',
}

